import { connect } from "react-redux";
import _ from "underscore";


var {AVG_QUIZ_SCORE, AVG_ANSWER_SCORE, STAT_DISPLAY, ACTIVITY_METRICS, RUBRIC_METRICS} = require("components/data/graphs/GraphUtility")
var DigestProgressGraph = require("components/data/graphs/DigestProgressGraph")

var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown"); 

require('data/graphs/activity_graph_container')
class DigestGraphWithDropdown extends React.Component {
	constructor(props) {
		super();
		autobind(this);

        // passed in when we want to graph rubric performance, not activity data
        if (props.rubricGraph){
            var startMetric = RUBRIC_METRICS[0]
        } else {
            var startMetric = ACTIVITY_METRICS[0]
        }
        
        
        this.state = {
            metric: startMetric
        }
    }

    changeMetric(selection){
        this.setState({metric: selection})
    }

    renderHeader(){
        var metricHeader = STAT_DISPLAY[this.state.metric].name

        if (this.props.rubricGraph){
            var metricsToList = RUBRIC_METRICS
            var prompt = "change skillset"
        } else {
            var metricsToList = ACTIVITY_METRICS
            var prompt = "change metric"
        }
        var activityOptions = _.map(metricsToList, metric=>{
            return <ButtonDropdownOption onClick={this.changeMetric.bind(this, metric)}
                text={STAT_DISPLAY[metric].name} key={metric}/>
        })

        
        var select = (
            <ButtonDropdown text={prompt} dropdownDisplay="link">
                {activityOptions}
            </ButtonDropdown>
        )

        return (
            <div className='header'>
                <div className='metricNames'>
                    {metricHeader}
                </div>
                {select}
            </div>
        )
    }

    render(){
        return (
            <div className='DigestGraphWithDropdown'>
                {this.renderHeader()}
                <DigestProgressGraph  metrics={[this.state.metric]} entity={this.props.entity} entityType={this.props.entityType}/>
            </div>
        )
    }
}

DigestGraphWithDropdown.propTypes = PageStrictPropTypes({
    entity: PropTypes.object,
    entityType: PropTypes.string
});

module.exports = DigestGraphWithDropdown


// WEBPACK FOOTER //
// ./modules/components/data/graphs/DigestGraphWithDropdown.js